var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadiusSearchCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#38424A",
    fillRule: "nonzero",
    d: "M13.672 6.125c.181 0 .328.147.328.328v1.094a.328.328 0 0 1-.328.328h-.83a5.91 5.91 0 0 1-4.967 4.967v.83a.328.328 0 0 1-.328.328H6.453a.328.328 0 0 1-.328-.328v-.83a5.91 5.91 0 0 1-4.967-4.967h-.83A.328.328 0 0 1 0 7.547V6.453c0-.181.147-.328.328-.328h.83a5.91 5.91 0 0 1 4.967-4.967v-.83c0-.181.147-.328.328-.328h1.094c.181 0 .328.147.328.328v.83a5.91 5.91 0 0 1 4.967 4.967h.83zm-5.8 4.928a4.149 4.149 0 0 0 3.18-3.18H9.946a.327.327 0 0 1-.327-.328v-1.09c0-.181.146-.328.327-.328h1.108a4.149 4.149 0 0 0-3.18-3.18v1.108c0 .181-.147.327-.328.327h-1.09a.327.327 0 0 1-.328-.327V2.947a4.149 4.149 0 0 0-3.18 3.18h1.108c.181 0 .327.147.327.328v1.09c0 .181-.146.328-.327.328H2.947a4.149 4.149 0 0 0 3.18 3.18V9.945c0-.181.147-.327.328-.327h1.09c.181 0 .328.146.328.327v1.108zm.233-4.421a.737.737 0 1 1-1.473 0 .737.737 0 0 1 1.473 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadiusSearchCard);
export default __webpack_public_path__ + "static/media/radius-search-card.cc6ede61898dd1e818a32b7613678d5a.svg";
export { ForwardRef as ReactComponent };